import { wglcsApiService } from "./WglcsApiService";
import { IOperationResult, LoginModel, LoginResponse } from "../models/index";
import EventEmitter, { Events } from "./eventemitter";
import { chatService } from "../services/chatService";
import { cookieService } from "./CookieService";
import { utils } from "../utils";
import moment from "moment";
// import Cookies from "universal-cookie";
// const cookies = new Cookies();

class LoginService {
    constructor() {
        EventEmitter.on(Events.onOperatorLogOut, this.logout);
    }

    private static readonly tokenKey = "authToken";
    private static readonly userData = "USER_DATA";

    async login(
        email: string,
        password: string,
        licenseKey: string,
        ipAddress: string,
        currentBrowser: string
    ): Promise<IOperationResult<LoginResponse>> {
        // TODO. Set IP Address and PC Name.
        let obj: LoginModel = {
            userName: email,
            password: password,
            licenseKey: licenseKey,
            ipAddress: ipAddress,
            computerName: currentBrowser,
        };

        try {
            var result = await wglcsApiService.signIn(obj);

            if (result.data && result.data.status) {
                wglcsApiService.setAuth(result.data.data.accessToken.auth_token);

                return { data: result.data.data, success: true } as IOperationResult<LoginResponse>;
            } else {
                throw new Error(`Authentication Failed with Error: ${result.data?.msg} `);
            }
        } catch (error) {
            return { message: error, success: false } as IOperationResult<LoginResponse>;
        }
    }

    logout = async (reason: string | null = null) => {

        var data = JSON.parse(localStorage.getItem("USER_DATA")!);

        await chatService.disconnect();

        await wglcsApiService.updateoperatorwindowstate(data?.userLoginData.userLog, false, true);

        cookieService.removeElectronCookies("RoutedSurveyCount")

        if (utils.isElectronBuild()) {
            var log = `[${moment().format("h:mm:ss DD/MM/YYYY")}] ---- method:logout -----User Name : ${data?.userLoginData?.username}`
            window.myAPI.LogoutLog(log)
        }
        if (utils.isElectronBuild()) {
            window.myAPI?.CloseChildWindows()
        }

        if (utils.isElectronBuild()) {
            cookieService.removeElectronCookies('USER_DATA')
        }
        let obj = {
            logId: data?.userLoginData.userLog,
        };
        await wglcsApiService.updateuserlog(obj);
        EventEmitter.emit(Events.onLogOut);
        // await cookies.remove("RoutedSurveyCount");
    };

    GetUserLoginData(): LoginResponse | null {
        var userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;

        if (userData === null) {
            return null;
        }

        return userData;
    }
}

var loginService = new LoginService();
export { loginService };
